export {
  getApplePayMerchantId,
  getCheckoutComPublicKey,
  getDomain,
  getEnvironment,
  getProtocol,
  getRecaptchaPublicKey,
  isDev,
  isProd,
} from './src/isomorphicEnvironment'
